import { Link } from "react-router-dom";
import Seo from "@/components/seo/Seo";

export default function NotFound() {
  return (
    <main className="min-h-[70vh] pt-[72px] flex items-center">
      <Seo
        title="Página no encontrada"
        description="La página solicitada no existe o fue trasladada."
        path={window.location.pathname}
        noindex
      />
      <div className="mx-auto max-w-[900px] px-5 md:px-10 py-24 text-center">
        <div className="eyebrow mb-6">Error 404</div>
        <h1 className="display-1">Página no encontrada.</h1>
        <p className="mt-6 text-[#4A4A4A]">
          La dirección ingresada no existe o el contenido fue trasladado.
        </p>
        <Link to="/" className="kb-btn mt-10 inline-flex">Volver al inicio</Link>
      </div>
    </main>
  );
}
